/**
 * Woher Bloecke eines Panels ihre Daten holen: in der App ueber die Datenabfrage (lib/widget-data-app.ts),
 * auf oeffentlichen Seiten ueber /oeffentlich/kacheln/<id>/daten. Als Kontext, damit die Kachel-Komponenten
 * selbst weder api noch Keycloak laden und im oeffentlichen Portal genauso laufen.
 */
import { createContext } from 'react';

export type Rows = Array<Record<string, unknown>>;

export interface WidgetDataSource {
  type: string;
  query?: string;
  dataset?: string;
  limit?: number;
  rows?: unknown;
}

/** `teil` = Index des Blocks im Panel (null bei einer einfachen Kachel). */
export type LoadWidgetData = (source: WidgetDataSource, teil: number | null) => Promise<Rows>;

export const WidgetDataContext = createContext<LoadWidgetData | null>(null);
